import React from 'react';
import { IProps as IFiftyFiftyVideoBlockProps } from './FiftyFiftyVideoBlock.interface';
import { FiftyFiftyVideoBlock } from './FiftyFiftyVideoBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IFiftyFiftyVideoBlockInputProps {
    heading?: string;
    content?: string;
    displayOrder?: string; // Example value 'rtl', could be 'rtl' | 'ltr'
    image?: any; // Assuming IImageProps is the interface for image objects
    buttons?: any[]; // Assuming IButtonProps is the interface for button objects
    videoSource?: string; // Example value 'youtube'
    videoId?: string;
    videoDescription?: string;
    mediaPosition?: 'left' | 'right';
    transcript?: string;
    background?: ThemeColors;
    parentClass?: string;
    anchorId?: string;
    containerId?: string;
    [key: string]: any;
}

const mapInputToProps = (input: IFiftyFiftyVideoBlockInputProps): IFiftyFiftyVideoBlockProps => {
    const { anchorId, containerId, displayOrder, heading, content, image, buttons, videoSource, videoDescription, mediaPosition, videoId, transcript, background, ...rest } = input;

    return {
        heading: heading,
        text: content,
        buttons: buttons?.map((button) => translation.mapAnchorProps(button)),
        video: { url: `https://${videoSource}.com/watch?v=${videoId}`, light: image?.defaultSrc, controls: true },
        transcript: transcript,
        transcriptButtonText: 'See Transcript',
        transcriptButtonTextOpen: 'Hide Transcript',
        videoDescription: videoDescription || undefined,
        mediaPosition: mediaPosition || 'right',
        backgroundColor: background || 'white',
        ...rest
    } as IFiftyFiftyVideoBlockProps; // Ensure the return type matches
};

const FiftyFiftyVideoBlockTranslation: React.FC<IFiftyFiftyVideoBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FiftyFiftyVideoBlock}
        mapProps={mapInputToProps}
    />
);

export default FiftyFiftyVideoBlockTranslation;